import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const fetchSiteKeys = async () => {
  const url = '/site-keys';
  return request.get(url);
};
